import { formatYoutubeVideo } from "~/common/utils/formatYoutubeVideo";
import LightBoxGallery from "../../components/LightBox/light-box";
import { SliderProduct2Props } from "./slider-product-2.types";
import { ImagesDetail } from "~/common/props/orchestrator";
import styles from "./slider-product-2.module.css";
import { useOutletContext } from "@remix-run/react";
import React, { useRef, useState } from "react";
import Flicking from "@egjs/react-flicking";
import { resizeImage, useAnalytics } from "@commons-monorepo/index";
import { LazyVideo } from "@components-monorepo/components/Video/lazy-video";
import { useArrows } from "@components-monorepo/components/products-slider/hooks";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";
import { ModalType, UiModal } from "@ui-monorepo/index";
import ImageZoom from "../../components/image-zoom";

const SliderProduct2 = ({ imagesDetail, videoUrl, className, disable }: SliderProduct2Props) => {
  const { theme } = useGlobalStyles();
  const { storeMetadata } = useOutletContext<any>();
  const [logEvent] = useAnalytics({ storeMetadata });
  const { isMobile } = useOutletContext<any>();
  const flickingRef = useRef<Flicking>(null);
  const flickingRef2 = useRef<Flicking>(null);
  const { next, prev } = useArrows(flickingRef);
  const { move: move2, next: next2, prev: prev2 } = useArrows(flickingRef2);
  const [showArrows, setShowArrows] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const onClose = () => {
    setShowModal(false);
  };

  const log = (source: string, option: string) => {
    logEvent("select_button", {
      event_subtype: "product_image_view",
      user_type: "buyer",
      platform: "web",
      source: source,
      option: option
    });
  };

  const previewSlider = isMobile ? imagesDetail && imagesDetail?.length > 1 : true;

  return (
    <div className={className}>
      <div aria-label='gallery-image-content-2' className={styles.slider2Container}>
        {previewSlider &&
        <div aria-label='gallery-thumb' className={styles.galleryThumbOnix}>
            {imagesDetail && imagesDetail?.length > 4 &&
          <button
            className={`${styles.controlButton} ${styles.prev}`}
            onClick={() => {
              prev(1);
              log("product_description", "slider_arrows");
            }}>

                <figure className={"icon-arrow-black"} />
              </button>}

            <Flicking
            className={styles.dumpCarousel}
            ref={flickingRef}
            horizontal={isMobile}
            cameraClass={styles.dumpCamera}
            panelsPerView={4}
            disableOnInit={imagesDetail && imagesDetail?.length < 4}
            align={"prev"}
            circular={imagesDetail && imagesDetail?.length > 4}>

              {imagesDetail?.map((photoItem: ImagesDetail, index) =>
            <div
              key={`${photoItem.url}-${index}`}
              className={`${styles.dumb} ${currentIndex === index && styles.active}`}
              onClick={() => {
                move2(index);
                log("product_description", "preview_image");
              }}>

                  <img
                className={disable ? styles.filterGray : ""}
                src={resizeImage(
                  photoItem.url,
                  100,
                  100,
                  80
                )}
                alt={photoItem.tags?.join(", ") || ""} />

                </div>
            )}
              {videoUrl && imagesDetail?.length &&
            <div key={456} className='thumb' onClick={() => move2(imagesDetail?.length)}>
                  <div className={styles.videoOverlay}>
                    <figure className={"icon-play-circle"} />
                  </div>
                </div>}

            </Flicking>
            {imagesDetail && imagesDetail?.length > 4 &&
          <button
            className={`${styles.controlButton} ${styles.next}`}
            onClick={() => {
              next(1);
              log("product_description", "slider_arrows");
            }}>

                <figure className={"icon-arrow-black"} />
              </button>}

          </div>}

        <div className={styles.slider}>
          <div aria-label='counter' className={styles.galleryImageCounts}>
            {currentIndex + 1} / {(imagesDetail?.length || 0) + (videoUrl ? 1 : 0)}
          </div>
          <Flicking
            cameraClass={styles.camera}
            panelsPerView={1}
            horizontal={true}
            ref={flickingRef2}
            resizeOnContentsReady={true}
            onMoveStart={() => {
              if (!isMobile) {
                setShowArrows(false);
              }
            }}
            onChanged={(e) => {
              setCurrentIndex(e.currentTarget.index);
              flickingRef?.current?.forceUpdate();
            }}
            onMoveEnd={(e) => {
              if (!isMobile) {
                setShowArrows(true);
              }
            }}
            align={"center"}
            circular={true}>

            {imagesDetail?.map((photoItem: ImagesDetail, index: number) =>
            <div className={styles.sliderCard} key={index}>
                <div
                className={styles.sliderImg}
                onClick={() => {
                  log("product_detail_image", "preview_image");
                  setShowModal(true);
                }}>

                  <img
                  className={disable ? styles.filterGray : ""}
                  src={resizeImage(photoItem.url, 700, 700, 80)}
                  alt={photoItem.tags?.join(", ") || ""} />

                </div>
              </div>
            )}
            {!!videoUrl &&
            <div aria-label='video-content' key={456} className={`${styles.videoThumb} ${styles.sliderCard}`}>
                <LazyVideo
                videoUrl={formatYoutubeVideo(videoUrl)}
                className='sliderProduct2'
                theme={theme}
                storeMetadata={storeMetadata} />

              </div>}

          </Flicking>
          {imagesDetail && imagesDetail?.length > 4 &&
          <div>
              <button
              className={`${styles.arrow} ${styles.prevArrow} ${showArrows && styles.show} flicking-arrow-prev`}
              onClick={() => {
                prev2();
                log("product_description", "main_arrows");
              }}>

                <figure className={"icon-arrow-black"} />
              </button>
              <button
              className={`${styles.arrow} ${styles.nextArrow} ${showArrows && styles.show} flicking-arrow-next`}
              onClick={() => {
                next2();
                log("product_description", "main_arrows");
              }}>

                <figure className={"icon-arrow-black"} />
              </button>
            </div>}

        </div>
        <UiModal
          title=''
          showHeader={false}
          content={{
            className: styles.modalContent
          }}
          onClose={onClose}
          show={showModal}>

          <LightBoxGallery
            indexPhotos={currentIndex}
            close={onClose}
            images={imagesDetail?.map((p) => p.url) || []}
            videosUrl={formatYoutubeVideo(videoUrl || "")}
            storeMetadata={storeMetadata}
            theme={theme}
            log={log} />

        </UiModal>
      </div>
    </div>);

};

export default SliderProduct2;